import { render, staticRenderFns } from "./injury.vue?vue&type=template&id=230ca839"
import script from "./injury.vue?vue&type=script&lang=js"
export * from "./injury.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports